import logo from '@/assets/wavelengths_logo_white.png';
import styles from './HomePage.module.css';

const services = [
  'Wash & Cut',
  'Wash, Cut, & Blow Dry',
  'Wash & Blow Dry',
  'Up-Do',
  'One Process Color',
  'Balayage',
  'Foil Highlights',
  'Perm',
  'Keratin Coppola Complex',
  'Keratin Express',
  'Olaplex Treatment',
  'Conditioning Treatment',
];

function HomePage() {
  return (
    <div className={styles.page}>
      <section className={styles.hero}>
        <img src={logo} alt="Wavelengths Hair Salon" className={styles.logo} />
        <h1 className={styles.established}>EST. 1980</h1>
        <h1 className={styles.moved}>We've moved to a new location!</h1>
        <h1 className={styles.address}>58 Kent Street Brookline Village Studio 104</h1>
        <h2 className={styles.contactLabel}>Contact</h2>
        <h3 className={styles.phone}>617-232-2116</h3>
        <div className={styles.bookingWrapper}>
          <a
            href="https://wavelengthstudio.glossgenius.com/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.bookingButton}
          >
            Book An Appointment
          </a>
        </div>
      </section>

      <section className={styles.services}>
        <h1 className={styles.servicesTitle}>Salon Services</h1>
        <table className={styles.servicesTable}>
          <tbody>
            {services.map((service) => (
              <tr key={service}>
                <td>{service}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <h2 className={styles.discount}>Student discounts available</h2>
      </section>
    </div>
  );
}

export default HomePage;
